.goldMobileFilters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 8px;
}

@media all and (--reefer-media-tablet-min) {
  .goldMobileFilters {
    display: none;
  }
}
